// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2QA9_","loaderOuter":"PageOverlayLoader_loaderOuter__3Lwa7"};